const DOCUMENT_SCANNING_TYPES_LIST_DATA = {
  titleData: {
    textList: [
      {
        id: 1,
        text: 'DOCUMENT SCANNING SPECIALTIES',
        textMob: 'document types',
        secondText: 'a look into our wide range of',
        secondTextMob: 'our wide range of',
        isTextReverse: true,
        isTextReverseMob: true,
        isTextColumn: true,
        isTextColumnMob: true,
        isLeft: false,
        isLeftMob: true,
        isRight: false,
        isRightMob: false,
        color: '#fff',
        colorMob: '#fff',
        isTextWithLine: false,
        isTextWithLineMob: false,
        isSecondTextWithLine: true,
        isSecondTextWithLineMob: false,
        firstTextLines: [],
        secondTextLines: [
          {
            id: 1,
            isLeftLine: false,
            isRightLine: true,
            isTopLine: false,
            isBottomLine: false,
            color: '#fff',
            isLineWithSquare: true,
            isLeftLineMob: false,
            isRightLineMob: true,
            isTopLineMob: false,
            isBottomLineMob: false,
            colorMob: '#fff',
            isLineWithSquareMob: true,
          },
        ],
      },
    ],
  },
  typesList: [
    {
      id: 1,
      title: 'Paper Documents',
      description: 'Everyday records like letters, certificates, and assignments scanned into organized convenient digital files.',
      descriptionMob: 'Everyday records like letters, certificates, and assignments scanned into organized convenient digital files.',
      image: '',
    },
    {
      id: 2,
      title: 'Genealogy Books',
      description: 'Family history collections digitized for easy sharing, searching, long-term preservation & reproduction.',
      descriptionMob: 'Family history collections digitized for easy sharing, searching, long-term preservation & reproduction.',
      image: '',
    },
    {
      id: 3,
      title: 'Historical Documents',
      description: 'Fragile papers such as immigration forms or war records & letters captured with archival accuracy.',
      descriptionMob: 'Fragile papers such as immigration forms or war records & letters captured with archival accuracy.',
      image: '',
    },
    {
      id: 4,
      title: 'Newspaper Clippings',
      description: 'Old clippings or entire pages scanned in high resolution to preserve both the text and its historical context.',
      descriptionMob: 'Old clippings or entire pages scanned in high resolution to preserve both the text and its historical context.',
      image: '',
    },
  ],
};

export default DOCUMENT_SCANNING_TYPES_LIST_DATA;
